// extracted by mini-css-extract-plugin
export default {"singleEmoji":"CommentPreview-module__singleEmoji--oqWv7","animatedBackground":"CommentPreview-module__animatedBackground--Splhc"};